import React, { FC } from 'react';

import { Stack, useDesktop, useMediaSwitch } from 'Modules/ui3';

import { News as NewsComponent } from '../../components/News';


export const News: FC = () => {
    const isDesktop = useDesktop();
    return (
        <Stack
            id='news'
            alignItems='center'
            px={useMediaSwitch(12, 6, 5)}
            py={useMediaSwitch(37, 6, 5)}
            mt={useMediaSwitch(0, -10, -8)}
            borderRadius='40px 40px 0 0'
            bgcolor='#fff'
            zIndex={1}
            {...!isDesktop && {
                borderRadius: '40px 40px 0 0',
            }}
        >
            <NewsComponent maxWidth='1200px' width='100%' rowCount={1} />
        </Stack>
    );
};
